module.exports = __webpack_public_path__ + "static/media/seg_presente.09f0ac53.png";